import type { Modifier, ClientRect } from '@dnd-kit/core';
import { getEventCoordinates } from '@dnd-kit/utilities';

/**
 * Just customized version of `snapToCenter` modifier from `@dnd-kit/modifiers`
 * @see https://github.com/clauderic/dnd-kit/blob/master/packages/modifiers/src/snapCenterToCursor.ts
 *  */
export const createSnapToPosition: (
  fn: (draggingNodeRect: ClientRect) => {
    x: number;
    y: number;
  },
) => Modifier =
  (relativeOffsetGetter) =>
  ({ activatorEvent, draggingNodeRect, transform }) => {
    if (draggingNodeRect && activatorEvent) {
      const activatorCoordinates = getEventCoordinates(activatorEvent);

      if (!activatorCoordinates) {
        return transform;
      }

      const offsetX = activatorCoordinates.x - draggingNodeRect.left;
      const offsetY = activatorCoordinates.y - draggingNodeRect.top;

      const relativeOffset = relativeOffsetGetter(draggingNodeRect);

      return {
        ...transform,
        x: transform.x + offsetX - relativeOffset.x,
        y: transform.y + offsetY - relativeOffset.y,
      };
    }

    return transform;
  };
